import { Component, Input, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReportTableService } from '../../../service/table/report-table-service';
import { Constants } from '../../../_model/constants';
import { TableResponse } from '../../../_model/table-response/table-response';
import { ClientStateService } from '../../navbar/client-state.service';
import { ReportMultipleInputFilterComponent } from '../../report-multiple-input-filter/report-multiple-input-filter.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  standalone: true,
  imports: [ReportMultipleInputFilterComponent, MatProgressSpinnerModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, FormsModule, MatAutocompleteModule, MatChipsModule, MatIconModule, MatButtonModule, MatDialogModule, MatTabsModule, MatToolbarModule, MatListModule, MatSidenavModule, MatExpansionModule, MatSnackBarModule, MatGridListModule, MatCheckboxModule, MatRadioModule],
  styleUrls: ['./report-table.component.scss']
})
export class ReportTableComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() reportTableService!: ReportTableService;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  tableData?: TableResponse;
  tableDisplayedColumns!: string[];
  isLoadingResults = true;
  length!: number;
  isLoadingData = false;
  indexColorArray: Array<number> = [];
  isColor = false;
  reportMessage! : string;
  showReportMessage = true;

  clientSubscription!: Subscription;
  paginatorSubscription!: Subscription;

  selectedFilters!: FormGroup<any> | null;

  constructor(private clientStateService: ClientStateService,
    private router: Router, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.selectedFilters = null;
    this.reportMessage = Constants.reportMessage;
    this.isLoadingData = true;
    this.initializeTable(0, 100, false);
    this.indexColorArray = [];

    this.clientSubscription = this.clientStateService.clientStateChanged$.subscribe(() => {

      this.selectedFilters = null;
      this.showReportMessage = true;
      this.indexColorArray = [];
      this.initializeTable(0, 100, true);

    });
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginatorSubscription = this.paginator.page.subscribe(event => {
        this.initializeTable(event.pageIndex, event.pageSize, false);
      });
    }
  }

  public initializeTable(page:number, size: number, clientSub: any) {
    //console.log(page, size, clientSub);
    this.isLoadingResults = true;
    if(clientSub) this.isLoadingData = false;
    this.indexColorArray = [];
    const filterFormGroup = this.selectedFilters || new FormGroup({});
    this.reportTableService.getTableData(filterFormGroup, page, size).subscribe({
      next: (result) => {
        this.isLoadingResults = false;
        this.tableData = result;
        //console.log(this.tableData);
        if (this.tableData?.data?.tableDefinitions) {
          this.tableDisplayedColumns = this.tableData.data.tableDefinitions.map(c => c.columnDef);
        }
        this.isLoadingData = true;
      },
      error: () => {
        this.isLoadingResults = false;
        this.isLoadingData = true;
      }
    })
  }

  onSelectedFilter(selectedFilter: FormGroup) {
    if ((selectedFilter.value && selectedFilter.value.tableFilter && selectedFilter.value.value) ||
      (selectedFilter && (typeof selectedFilter.value.multipleFilterarray != "undefined"
        && selectedFilter.value.multipleFilterarray != null
        && selectedFilter.value.multipleFilterarray.length != null
        && selectedFilter.value.multipleFilterarray.length > 0))) {
      this.selectedFilters = selectedFilter;
      this.showReportMessage = false;
    } else {
      this.selectedFilters = null;
      this.showReportMessage = true;
    }
    this.initializeTable(0, 100, false);
  }

  customIndex(index: number, colorArr: any): Boolean {
    colorArr.forEach((value: any, index: number) => {
      if (value === 'COMPLETE') {
        this.indexColorArray.push(index);
      }
    });
    if (this.indexColorArray.includes(index) === true) {
      this.isColor = true;
    } else {
      this.isColor = false;
    }
    this.indexColorArray = [];
    return this.isColor;

  }

    customIndexMatched(index: number, colorArr: any): Boolean {
      colorArr.forEach((value: any, index: number) => {
        if (value === 'MATCHED') {
          this.indexColorArray.push(index);
        }
      });
      if (this.indexColorArray.includes(index) === true) {
        this.isColor = true;
      } else {
        this.isColor = false;
      }
      this.indexColorArray = [];
      return this.isColor;

    }

  customIndexClosed(index: number, colorArr: any): Boolean {
      colorArr.forEach((value: any, index: number) => {
        if (value === 'CLOSED') {
          this.indexColorArray.push(index);
        }
      });
      if (this.indexColorArray.includes(index) === true) {
        this.isColor = true;
      } else {
        this.isColor = false;
      }
      this.indexColorArray = [];
      return this.isColor;

    }

    customIndexInvoiced(index: number, colorArr: any): Boolean {
      colorArr.forEach((value: any, index: number) => {
        if (value === 'INVOICED') {
          this.indexColorArray.push(index);
        }
      });
      if (this.indexColorArray.includes(index) === true) {
        this.isColor = true;
      } else {
        this.isColor = false;
      }
      this.indexColorArray = [];
      return this.isColor;

    }


  ngOnDestroy(): void {
    this.clientSubscription.unsubscribe();
  }

}
